/* eslint-disable import/first */
import React, { useState, useContext, useEffect } from 'react';
import Hreflang from '../../components/Hreflang';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import debounce from 'lodash/debounce';
import { useNavigate, useLocation } from '@reach/router';
import { Button, Paper, Grid, Typography, Dialog } from '@material-ui/core';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';
const { selectDesktop } = Slices.appSlice;
const { fetchOffers, addCoupon } = Slices.offerSlice;
const { selectAllMain } = Slices.categorySlice;
const { getClusterId } = Slices.configSlice;
import Header from '../../components/Header';
const { fetchDiscountedItems } = Slices.menuSlice;
import LanguageButton from '../../components/LanguageButton';
import { Context } from './../../components/Multi-lang/Wrapper';
// import Badge from '../../components/Icons/Badge';
const { cartAmount, cartAppliedPromos, sendCart } = Slices.cartSlice;
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline';
const { selectLoginStatus } = Slices.authSlice;
import OfferApplied from '../OfferApplied';
import {
  couponApplyGA,
  applyCouponFailureGA,
  applyCouponSuccessGA,
  binCouponApplyGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import NoOffer from './NoOffer';
import artWork from './offerArtwork.svg';
const { selectDefaultAddress } = Slices.addressSlice;
const { setCurrentCat } = Slices.categorySlice;
const { selectCurrentCurrency } = Slices.configSlice;
import ErrorOfferPopUp from './ErrorOfferPopUp';
import css from './index.module.scss';
import Loader from '../../components/Loader';
import couponCode from './scissors.svg';
import MinimumErrorPopup from './MinimumErrorPopup';
import RenderTC from './RenderTC';

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));
function Offers({ action, ret = '/' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(Context);
  const intl = useIntl();
  const currency = useSelector(selectCurrentCurrency);
  const [status, setStatus] = React.useState('initial');
  const dispatch = useDispatch();

  const offers = useSelector((state) => state.offer);
  const cartData = useSelector((state) => state.cart);
  const address = useSelector(selectDefaultAddress);
  const [confettiStatus, setConfettiStatus] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [dialogState, setDialogState] = useState(true);
  const clusterId = useSelector(getClusterId);
  const [openTc, setOpenTc] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [offerCode, setOfferCode] = useState('');
  const [errorOffer, setErrorOffer] = useState('');
  const [offerError, setOfferError] = useState('');
  const [amountAddMore, setAmountAdd] = useState(0);
  const [isDiscountedItem, setIsDiscountedItem] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const isDesktop = useSelector(selectDesktop);
  const user = useSelector(selectLoginStatus);
  const cartAmountDetail = useSelector(cartAmount);
  const appliedCoupon = useSelector(cartAppliedPromos);
  const [totalCartAmount, setTotalCartAmount] = useState(0);
  const [showErrorWithTerms, setShowErrorWithTerms] = useState(false);
  const [miniError, setMiniError] = useState(false);
  const categories = useSelector(selectAllMain);
  const result = categories?.sort((a, b) => a.position - b.position);
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;

  useEffect(() => {
    cartAmountDetail.forEach((item) => {
      item.code === 'SUB_TOTAL' && setTotalCartAmount(item.amount);
    });
  }, [totalCartAmount, cartAmountDetail]);

  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      // maxWidth: '26rem',
      borderRadius: '2rem',
      backgroundColor: '#F1F3F6',
      backgroundImage: `url(${artWork})`,
      height: 'auto',
      width: '26rem',
    },
  }));
  const vardialogPaper = useStyles();
  useEffect(() => {
    const payload = {
      page: 1,
    };
    const debouncedDispatch = debounce(dispatch, 500);
    debouncedDispatch(fetchOffers(payload));
    return () => {
      // Cancel the debounced function
      debouncedDispatch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyCoupon = (offer, amount, payload) => {
    dispatch(addCoupon(offer));
    const discountValue = amount.filter((val) => val.type === 'DISCOUNT');
    setDiscountAmount(discountValue[0]?.amount);
    if (offer.noonPayPromoid !== '') {
      binCouponApplyGA(offer.couponCode, discountValue[0]?.amount);
    }
    couponApplyGA(offer.couponCode, user);

    if (payload?.freeCategoryId && payload?.freeCategoryId !== 0) {
      navigate(`/${context.locale}/cart`, {
        state: {
          cartLocation: location?.state?.oldLocation,
        },
        replace: true,
      });
    } else {
      isDesktop
        ? navigate(`/${context.locale}/offer-applied`, {
            state: {
              oldLocation: location?.state?.oldLocation,
              discount: discountValue[0]?.amount,
            },
            replace: true,
          })
        : setConfettiStatus(true);
    }
  };
  const postCart = (offerCoupon) => {
    setPageLoader(true);
    let addressType = 'DELIVERY';
    let addressSubType = 'DELIVERY';
    if (Object.entries(address).length) {
      addressType = address.addressType;
      addressSubType = address.addressSubType;
    }

    const payload = {
      body: {
        addressSubType: addressSubType,
        addressType: addressType,
        addressId: address?.id || '',
        cartId: cartData.data.cartId,
        applySurprisePromo: offerCoupon.length > 0,
        couponCode: offerCoupon || offerCode,
        clusterId: clusterId || '',
        items: cartData.data.items,
        version: 'v20',
        orderType: addressType,
        storeId: address?.storeId,
      },
      headers: { country: cartData.data.country },
    };
    dispatch(sendCart(payload)).then((resp) => {
      const responseLoad = resp.payload.data.data;
      try {
        if (responseLoad.couponApplied) {
          applyCouponSuccessGA(offerCoupon || offerCode, user);
          applyCoupon(responseLoad.promo, responseLoad.amount, responseLoad);
        } else if (responseLoad?.freeCategoryId && responseLoad?.freeCategoryId !== 0) {
          // setIsDiscountedItem(true);
          // console.log('free333');
          applyCoupon(responseLoad.promo, responseLoad.amount, responseLoad);
          dispatch(
            fetchDiscountedItems({
              id: responseLoad?.freeCategoryId,
              cluster: clusterId,
              Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
            })
          ).then((res) => {
            // setTimeout(() => {
            //   navigate(`/${intl.locale}/cart`);
            // }, 300);
            navigate(`/${intl.locale}/cart`);
          });
        } else if (responseLoad.couponApplied === 0 && offerCode) {
          const promo = offers.data.info.list.find((offer) => offer.couponCode === offerCode);
          if (responseLoad?.promo) {
            dispatch(addCoupon(responseLoad?.promo));
            console.log(totalCartAmount < responseLoad?.promo?.minCartAmt);
            if (totalCartAmount < responseLoad?.promo?.minCartAmt) {
              setDiscountAmount(responseLoad?.promo?.minCartAmt - totalCartAmount);
              setAmountAdd(responseLoad?.promo?.minCartAmt - totalCartAmount);
              setMiniError((prev) => true);
            } else {
              setShowErrorWithTerms(true);
            }
          }
          setErrorOffer(
            <FormattedMessage id="offer_error" defaultMessage="You have entered an Invalid code." />
          );
          applyCouponFailureGA(offerCoupon || offerCode, user);
        } else if (responseLoad.couponApplied === 0) {
          if (responseLoad?.promo) {
            dispatch(addCoupon(responseLoad?.promo));
            console.log(totalCartAmount < responseLoad?.promo?.minCartAmt);
            if (totalCartAmount < responseLoad?.promo?.minCartAmt) {
              setDiscountAmount(responseLoad?.promo?.minCartAmt - totalCartAmount);
              setAmountAdd(responseLoad?.promo?.minCartAmt - totalCartAmount);
              setMiniError((prev) => true);
            } else {
              setShowErrorWithTerms(true);
            }
          }
        } else {
          setOfferError(
            intl.formatMessage(
              {
                id: 'CouponBox_offerNotApplied',
                defaultMessage: 'Offer {offer} not applied on this order',
              },
              {
                offer:
                  findOfferWithCouponCode(offerCoupon) &&
                  findOfferWithCouponCode(offerCoupon).couponHidden == 1
                    ? ''
                    : offerCoupon,
              }
            )
          );
          applyCouponFailureGA(offerCoupon || offerCode, user);
        }

        applyCouponFailureGA(offerCoupon || offerCode, user);
        setPageLoader(false);
      } catch (error) {
        console.log(error);
      }
    });
  };

  const handleClose = () => {
    setDialogState(false);
    // if (action === 'cart') {
    navigate(-1);
    // } else {
    //   navigate(`/${context.locale}/home`, { replace: true });
    // }
  };
  //const [termsAccordState, setTermsAccordState] = useState(false);
  const [accArray, setAccArray] = useState([]);

  const setAccordionStatus = (index) => {
    const list = [...accArray];
    list[index] = !list[index];
    //setTermsAccordState(!termsAccordState);
    setAccArray(list);
  };
  const handleCode = (e) => {
    setOfferCode(e.target.value);
  };
  const removeCode = () => {
    setOfferCode('');
    setErrorOffer('');
  };

  const navigateToExplore = () => {
    const categoryId = exploreMenuPath?.split('/')?.[3];
    dispatch(setCurrentCat(categoryId));
    navigate(exploreMenuPath);
  };

  const findOfferWithCouponCode = (couponCode) => {
    return offers.data?.info?.list?.find((offer) => offer.couponCode == couponCode);
  };
  const goTocart = () => {
    navigate(`/${intl.locale}/cart`, { replace: true });
    // setMinimumErr((pre) => false);
  };

  return (
    <div className={css.root}>
      <Hreflang page="offers" />
      {pageLoader && <Loader />}
      {!isDesktop ? (
        <Header
          title={<FormattedMessage id="navigation_offers" defaultMessage="Offers" />}
          actionButtons={[<LanguageButton />]}
        />
      ) : (
        <div className={css.header}>
          <div className={css.backButton} onClick={handleClose}>
            <IoIosArrowForward />
          </div>
          <div className={css.mainHeading}>
            <FormattedMessage id="add_coupon" defaultMessage="Add Coupon" />
          </div>
        </div>
      )}

      <Grid className={css.root}>
        {cartData.cartValue > 0 && (
          <div className={css.input}>
            <input
              type="text"
              onChange={handleCode}
              value={offerCode || ''}
              placeholder={intl.formatMessage({ id: 'offer_code_placeholder' })}
            />
            <div className={css.apply}>
              <Button
                variant="contained"
                color="primary"
                // disabled={offerCode === ''}
                onClick={() => postCart('')}
              >
                <FormattedMessage id="offers_apply" defaultMessage="Apply" />
              </Button>
            </div>
            {offerCode && (
              <Button onClick={removeCode} className={css.close}>
                x
              </Button>
            )}
            {errorOffer && (
              <div className={css.error}>
                {' '}
                <MdErrorOutline size={20} />
                {errorOffer}
              </div>
            )}
          </div>
        )}
        <Grid className={css.pageHeadText}>
          {offers.data?.info?.list?.length > 0 && (
            <Typography>
              <FormattedMessage id="availableCoupons" defaultMessage="Available Coupons" />
            </Typography>
          )}
        </Grid>
        {offers.data?.info?.list?.length == 0 && <NoOffer callback={navigateToExplore} />}
        {offers.data?.info?.list?.length > 0 &&
          offers.data?.info?.list?.map((value, index) => {
            let validCoupon = false;
            if (value.isVisible) {
              if (
                totalCartAmount >= value.minCartAmt &&
                appliedCoupon?.couponId !== value?.couponId
              ) {
                validCoupon = true;
              }
              if (!value.orderType.includes(address?.addressSubType || 'DELIVERY')) {
                validCoupon = false;
              }
              return (
                <Paper className={css.couponPaper} key={index}>
                  <Grid className={css.couponContainer}>
                    {/* <Grid className={css.badge}>
                      <Badge />
                    </Grid> */}
                    <Grid className={css.couponHeader}>
                      <Grid className={css.headerText}>
                        <Typography>{value[`ruleName_${context.locale}`]}</Typography>
                      </Grid>
                      {value?.couponHidden && value.couponHidden == 1 ? (
                        ''
                      ) : (
                        <Grid className={css.couponCode}>
                          {value.couponCode}
                          <span>
                            <img src={couponCode} alt="" />
                          </span>
                        </Grid>
                      )}
                    </Grid>
                    <Grid className={css.couponDesc}>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html:
                            context.locale === 'en' || context.locale === 'ar'
                              ? value[`shortDesc_${context.locale}`]
                              : '',
                        }}
                      />
                    </Grid>
                    <Grid className={css.dashedArea}>
                      <div className={css.line} />
                    </Grid>
                    <Grid className={css.termsContainer}>
                      <Grid className={css.terms} onClick={() => setAccordionStatus(index)}>
                        {/* <Grid className={css.iconArea}>
                          <RiErrorWarningLine className={css.icon} />
                        </Grid> */}
                        <Typography>
                          <FormattedMessage
                            id="navigation_termsCondition"
                            defaultMessage="Terms & Conditions"
                          />
                        </Typography>
                      </Grid>
                      <Grid>
                        {/* || appliedCoupon?.couponId === value?.couponId */}
                        <Button
                          variant="contained"
                          color="primary"
                          // className={css.applyButton}
                          onClick={() => postCart(value.couponCode)}
                          disabled={!validCoupon}
                        >
                          {appliedCoupon?.couponId === value?.couponId ? (
                            <FormattedMessage id="offerApplied" defaultMessage="Applied" />
                          ) : (
                            <FormattedMessage id="offers_apply" defaultMessage="Apply" />
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid className={css.couponDesc}>
                      {accArray[index] && (
                        <Grid className={css.termsContainer}>
                          <Typography
                            dangerouslySetInnerHTML={{
                              __html: context.locale === 'en' ? value.tnc_en : value.tnc_ar,
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              );
            }
          })}
      </Grid>
      {confettiStatus && (
        <Grid>
          <Dialog open={true} classes={{ paper: vardialogPaper.dialogPaper }}>
            <OfferApplied
              vardialogPaper={vardialogPaper}
              handleClose={handleClose}
              discountAmount={discountAmount}
              isCouponHidden={appliedCoupon.couponHidden}
            />
          </Dialog>
        </Grid>
      )}
      {!isDiscountedItem && errorPopup && (
        //error show
        <ErrorOfferPopUp
          offerError={offerError}
          setErrorPopup={setErrorPopup}
          isDesktop={isDesktop}
        />
      )}
      {miniError && (
        //error show
        <MinimumErrorPopup
          navigateToExplore={navigateToExplore}
          isTermsOpen={openTc}
          setIsTermsOpen={() => {
            setOpenTc(true);
            setMiniError(false);
          }}
          goTocart={() => setMiniError(false)}
          amountAddMore={amountAddMore}
          currency={currency}
          offerError={offerError}
          setErrorPopup={setErrorPopup}
          isDesktop={isDesktop}
        />
      )}
      {openTc && (
        <RenderTC
          setIsTermsOpen={() => {
            setOpenTc(false);
            setMiniError(false);
          }}
          isTermsOpen={openTc}
        />
      )}
      {showErrorWithTerms && (
        <MinimumErrorPopup
          termsErrorView={true}
          navigateToExplore={navigateToExplore}
          isTermsOpen={openTc}
          setIsTermsOpen={() => {
            setOpenTc(true);
            setMiniError(false);
          }}
          goTocart={() => setShowErrorWithTerms(false)}
          amountAddMore={amountAddMore}
          currency={currency}
          offerError={offerError}
          setErrorPopup={setErrorPopup}
          isDesktop={isDesktop}
        />
      )}
      <footer className={css.footer}></footer>
    </div>
  );
}

export default Offers;
